import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import FilterMint from "../filters/FilterMint.vue";
import FilterAmount from "../filters/FilterAmount.vue";
import FilterWallet from "../filters/FilterWallet.vue";
import {EFilterOperatorsParity, FilterOperatorsBitmap, getFiltersByKey, ISignalFilters} from "@/shared";
import FilterOperators from "../filters/FilterOperators.vue";
import FiltersGeneric from "@/components/automation/filters/FiltersGeneric.vue";

// props
interface IProps {
	data?: any;
	filters?: ISignalFilters;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SignalTokenTransfer',
  props: {
    data: null,
    filters: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	data?: any;
	filters?: ISignalFilters;
};



const _availableFilters = [
	{key: "amount", name: "Transfer Amount", operator: 0, type: "uint64", value: null},
	{key: "srcWallet", name: "From Wallet", operator: 0, type: "wallet", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsParity)},
	{key: "dstWallet", name: "To Wallet", operator: 0, type: "wallet", value: null, ops: new FilterOperatorsBitmap(EFilterOperatorsParity)},
]


const isInvalid = computed<boolean>(
	() => {
		for (let i = 0; i < FilterGenericRef.value?.data.length; i++) {
			if (!FilterGenericRef.value?.data[i]?.value || FilterGenericRef.value?.data[i]?.value === 0) return true
		}
		return false

	});

const getData = computed<any>(() => {
	return {
		mint: mint.value,
		filters: FilterGenericRef.value?.data,
	};
});

// methods

// data
const FilterGenericRef = ref<InstanceType<typeof FiltersGeneric> | null>(null);

const mint = ref<string>(props.data?.mint ?? "");

// expose
expose({isInvalid, data: getData});

return { __sfc: true,props, _availableFilters, isInvalid, getData, FilterGenericRef, mint, FilterMint, FiltersGeneric }
}

})